import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

export const getHsaPaymentAnalyticsForTeam = {
  name: "getHsaPaymentAnalyticsForTeam" as const,
  input: z.object({
    teamId: zExt.objectId(),
    startDate: isoDate,
    endDate: isoDate,
  }),
  output: z.object({
    series: z.array(
      z.object({ date: z.string(), orders: z.number(), grossUsd: z.number() }),
    ),
    totalOrders: z.number(),
    totalGrossUsd: z.number(),
    /**
     * Whether the merchant's Shopify payments report could be queried — false
     * when the merchant hasn't granted `read_reports` or Shopify returned an
     * error, so the UI can distinguish "no access" from "no activity".
     */
    reporting: z.boolean(),
  }),
};
